var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, createContext } from 'react';
export var AppLoaderContext = /*#__PURE__*/createContext({
  appLoading: false,
  setAppLoading: function () {}
});
var AppLoaderProvider = function (_a) {
  var children = _a.children;
  var _b = useState(false),
    appLoading = _b[0],
    setAppLoading = _b[1];
  return _jsx(AppLoaderContext.Provider, __assign({
    value: {
      appLoading: appLoading,
      setAppLoading: setAppLoading
    }
  }, {
    children: children
  }));
};
export default AppLoaderProvider;